export default __webpack_public_path__ + "89672bb87b554835c0a18c8e4089252b.png";